export const notesMessagesAlertColumnsNameMap: Map<string, string> = new Map([
  ["astId", "AST Id"],
  ["labSheet", "Lab Notes"],
  ["resultSheet", "Clinical Notes"],
  ["messages", "Messages"],
  ["ipcAlerts", "IPC Alerts"]
]);
